/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type AdVehicleStreamDoorRequestStatusSubscriptionVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type AdVehicleStreamDoorRequestStatusSubscription = {
  __typename?: 'Subscription'
  fccDoorRequestStatus: {
    __typename?: 'FccDoorRequestStatus'
    vehicleId: string
    status: Types.FccRequestStatus
    errors: Array<Types.FccDoorActuationError>
  }
}

export const AdVehicleStreamDoorRequestStatusDocument = gql`
    subscription AdVehicleStreamDoorRequestStatus($vehicleId: ID!) {
  fccDoorRequestStatus(vehicleId: $vehicleId) {
    vehicleId
    status
    errors
  }
}
    `

/**
 * __useAdVehicleStreamDoorRequestStatusSubscription__
 *
 * To run a query within a React component, call `useAdVehicleStreamDoorRequestStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamDoorRequestStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamDoorRequestStatusSubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamDoorRequestStatusSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AdVehicleStreamDoorRequestStatusSubscription,
    AdVehicleStreamDoorRequestStatusSubscriptionVariables
  > &
    (
      | {
          variables: AdVehicleStreamDoorRequestStatusSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    AdVehicleStreamDoorRequestStatusSubscription,
    AdVehicleStreamDoorRequestStatusSubscriptionVariables
  >(AdVehicleStreamDoorRequestStatusDocument, options)
}
export type AdVehicleStreamDoorRequestStatusSubscriptionHookResult = ReturnType<
  typeof useAdVehicleStreamDoorRequestStatusSubscription
>
export type AdVehicleStreamDoorRequestStatusSubscriptionResult =
  Apollo.SubscriptionResult<AdVehicleStreamDoorRequestStatusSubscription>
